import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokAdGroups.graphql';
import { Query, QuerytiktokAdGroupsArgs } from '../../__generated__/globalTypes';

export const useTiktokAdGroupsQuery = (options?: QueryHookOptions<Query, QuerytiktokAdGroupsArgs>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokAdGroupsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokAdGroupsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokAdGroupsArgs>
): QueryResult<Query, QuerytiktokAdGroupsArgs> & {
  getTiktokAdGroups: LazyQueryExecFunction<Query, QuerytiktokAdGroupsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokAdGroups, result] = useLazyQuery<Query, QuerytiktokAdGroupsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getTiktokAdGroups, ...result };
};

export const useTiktokAdGroupsPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokAdGroups = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokAdGroupsArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokAdGroupsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokAdGroups };
};
// Suspense Query Hooks
export const useTiktokAdGroupsSuspenseQuery = (options?: SuspenseQueryHookOptions<Query, QuerytiktokAdGroupsArgs>) => {
  const result = useSuspenseQuery<Query, QuerytiktokAdGroupsArgs>(QUERY, {
    ...options
  });

  return result;
};
